import { Link } from "react-router-dom";
import { newsCategories } from "@/mocks/categories";

function Footer() {
  const nav = [
    { to: "/", label: "首页" },
    { to: "/live", label: "直播频道" },
    { to: "/about", label: "关于我们" },
  ];

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-flex items-baseline gap-1.5">
              <span className="font-heading text-2xl font-black leading-none text-primary-600">
                吃瓜<span className="text-foreground-950">新闻</span>
              </span>
            </Link>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              一个全天滚动更新的每日快讯频道。今日要闻、早报晚报、即时速递与直播内容一站掌握，帮你在最短时间里看遍一天大事。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
                <i className="ri-flashlight-line" /> 信息可溯
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
                <i className="ri-check-double-line" /> 编辑核实
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-900">栏目导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-2 gap-y-2.5">
              {newsCategories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600"
                  >
                    {c.name}快讯
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-900">频道直达</h3>
            <ul className="mt-4 space-y-2.5">
              {nav.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-sm text-foreground-600 hover:text-primary-600">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-foreground-900">订阅与反馈</h3>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              欢迎通过「关于我们」页面的投稿与联系表单，或加入早报订阅，第一时间收到每日要闻汇总。
            </p>
            <div className="mt-4 flex flex-col gap-2 text-sm text-foreground-600">
              <span className="inline-flex items-center gap-2">
                <i className="ri-mail-line text-primary-500" /> contact@chigua-news.example
              </span>
              <span className="inline-flex items-center gap-2">
                <i className="ri-time-line text-primary-500" /> 工作日 08:30 - 22:00
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex max-w-6xl flex-col gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© 2026 吃瓜新闻 · 每日快讯频道，内容仅供阅读参考。</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-heart-3-line text-primary-500" />
            用心做好每一天的新闻早餐
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;